"use client";

import type { StatusId } from "@/lib/types";
import { STATUSES } from "@/lib/constants";

export function StatusIcon({ status, size = 14 }: { status: StatusId; size?: number }) {
  const s = STATUSES.find((x) => x.id === status)!;
  const color = s.color;
  const r = size / 2;
  const cx = r;
  const cy = r;
  const strokeWidth = Math.max(1.5, size / 10);
  const inner = r - strokeWidth;

  if (status === "backlog") {
    const dash = (2 * Math.PI * inner) / 16;
    return (
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-label="Backlog">
        <circle
          cx={cx}
          cy={cy}
          r={inner}
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeDasharray={`${dash} ${dash}`}
        />
      </svg>
    );
  }

  if (status === "todo") {
    return (
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-label="Todo">
        <circle cx={cx} cy={cy} r={inner} fill="none" stroke={color} strokeWidth={strokeWidth} />
      </svg>
    );
  }

  if (status === "in_progress" || status === "in_review") {
    const pct = status === "in_progress" ? 0.5 : 0.75;
    const circumference = 2 * Math.PI * inner;
    return (
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-label={status}>
        <circle cx={cx} cy={cy} r={inner} fill="none" stroke={color} strokeWidth={strokeWidth} opacity={0.35} />
        <circle
          cx={cx}
          cy={cy}
          r={inner}
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeDasharray={`${circumference * pct} ${circumference}`}
          transform={`rotate(-90 ${cx} ${cy})`}
          strokeLinecap="round"
        />
      </svg>
    );
  }

  if (status === "done") {
    return (
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-label="Done">
        <circle cx={cx} cy={cy} r={inner} fill={color} />
        <path
          d={`M ${cx - inner * 0.45} ${cy} L ${cx - inner * 0.1} ${cy + inner * 0.4} L ${cx + inner * 0.55} ${cy - inner * 0.35}`}
          fill="none"
          stroke="#08090a"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  // canceled
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-label="Canceled">
      <circle cx={cx} cy={cy} r={inner} fill={color} />
      <path
        d={`M ${cx - inner * 0.4} ${cy - inner * 0.4} L ${cx + inner * 0.4} ${cy + inner * 0.4} M ${cx + inner * 0.4} ${cy - inner * 0.4} L ${cx - inner * 0.4} ${cy + inner * 0.4}`}
        stroke="#08090a"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
}
